var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5V17C9 18.08 8.55999 19.07 7.85999 19.79L7.82001 19.83C7.73001 19.92 7.63001 20.01 7.54001 20.08C7.24001 20.34 6.89999 20.54 6.54999 20.68C6.43999 20.73 6.33 20.77 6.22 20.81C5.83 20.94 5.41 21 5 21C4.73 21 4.46001 20.97 4.20001 20.92C4.07001 20.89 3.94 20.86 3.81 20.82C3.65 20.77 3.50001 20.72 3.35001 20.65C3.35001 20.64 3.35 20.64 3.34 20.65C3.06 20.51 2.79001 20.35 2.54001 20.16L2.53 20.15C2.4 20.05 2.28001 19.95 2.17001 19.83C2.06001 19.71 1.95 19.59 1.84 19.46C1.65 19.21 1.49001 18.94 1.35001 18.66C1.36001 18.65 1.36001 18.65 1.35001 18.65C1.35001 18.65 1.35 18.64 1.34 18.63C1.28 18.49 1.22999 18.34 1.17999 18.19C1.13999 18.06 1.10999 17.93 1.07999 17.8C1.02999 17.54 1 17.27 1 17V3.5C1 2 2 1 3.5 1H6.5C8 1 9 2 9 3.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.5V18.5C21 20 20 21 18.5 21H5C5.41 21 5.83 20.94 6.22 20.81C6.33 20.77 6.43999 20.73 6.54999 20.68C6.89999 20.54 7.24001 20.34 7.54001 20.08C7.63001 20.01 7.73001 19.92 7.82001 19.83L7.85999 19.79L14.66 13H18.5C20 13 21 14 21 15.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81 20.8199C3.21 20.6399 2.64001 20.3099 2.17001 19.8299C1.69001 19.3599 1.35999 18.7899 1.17999 18.1899C1.56999 19.4399 2.56 20.4299 3.81 20.8199Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.37 10.2899L14.66 13L7.85999 19.7899C8.55999 19.0699 9 18.08 9 17V7.33995L11.71 4.62996C12.77 3.56996 14.19 3.56996 15.25 4.62996L17.37 6.74996C18.43 7.80996 18.43 9.22995 17.37 10.2899Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18C5.55228 18 6 17.5523 6 17C6 16.4477 5.55228 16 5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeManager);
export default __webpack_public_path__ + "static/media/themeManager.9984fd57.svg";
export { ForwardRef as ReactComponent };